import { InjectionToken } from '@angular/core';
import { LoadingService } from '@selfai-platform/shared';

export const LOADING_ROUTES_SAVE = new InjectionToken<LoadingService>('LoadingRoutesSave');